import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";

const icons = [
  { name: "Coffee Shop", icon: <FaCoffee /> },
  { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
  { name: "Fish & Seafood", icon: <FaFish /> },
  { name: "Supermarket", icon: <FaStore /> },
  { name: "Restaurant", icon: <FaUtensils /> },
  { name: "Ice Cream", icon: <FaIceCream /> },
  { name: "Chocolate", icon: <FaCookieBite /> },
];

const models = [
  { name: "Vista", image: "images/vista2.jpg", description: "Compact display units with large capacity and superior visibility.", slug: "vista" },
  { name: "E-Line", image: "images/neweline.jpg", description: "Versatile and compact, ideal for medium-sized stores.", slug: "e-line" },
  { name: "Kubo", image: "images/newkubo.jpg", description: "An urban and contemporary concept.", slug: "kubo" },
  { name: "Daisy", image: "images/newdaisy.jpg", description: "Versatile and functional display units with all the options for food retail and foodservice.", slug: "daisy-lower" },
  { name: "Minimal", image: "images/newminimal.jpg", description: "Less is more, a multitude of options for endless configurations.", slug: "minimal" },
  { name: "Scoop", image: "images/newscoop.jpg", description: "Performance and visibility, your ice cream always at its best.", slug: "scoop" },
  { name: "Iris", image: "images/newiris.jpg", description: "The visibility and the highlight that your products deserve.", slug: "iris" },
  { name: "FUTURO 2", category: "Multi decks", image: "images/futunew.jpg", description: "The most complete and flexible solution for modern food retail.", slug: "FUTURO-22" },
 
  { name: "Columbus", image: "images/newcolumbs.jpg", description: "High capacity and visibility without obstacles.", slug: "columbus-lower" },
  { name: "Pura", image: "images/newpura.jpg", description: "The ultimate gelato experience.", slug: "pura" },
  { name: "Prestige2", image: "images/newprestige2.jpg", description: "The display that loves your Meat and Charcuterie products.", slug: "prestige2" },
  { name: "PassionLux", image: "images/newpassionlux.jpg", description: "Wide area of exposure and sophistication in a single exhibitor.", slug: "passionlux" },
];


function Display() {
  const itemsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(models.length / itemsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const selectedModels = models.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="w-full font-thin mb-20">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/displaycasesland.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></section>

      {/* Models Display */}
      <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Display Cases & Serve-Overs</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          Cold, hot or dry/ambient, for Ice-cream, Chocolates, …, we offer a complete range of Display Cases and Serve-Overs, with different styles and for the most varied sectors, which allow an always perfect look!
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline uppercase mt-6">Typologies</Link>
        </div>
      </section>

      {/* Products Grid */}
      <section className="px-2 lg:px-32">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
          {selectedModels.map((model, index) => (
            <div key={index} className="text-center">
                     <Link to={`/${encodeURIComponent((model.slug || "").replace(/\s+/g, "-").replace(/&/g, "and"))}`}>

                <div
                  className="relative w-full h-80 md:mb-4"
                  style={{
                    backgroundImage: `url(${model.image})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    height: "300px",
                  }}
                ></div>
                <h3 className="text-3xl font-thin mb-2">{model.name}</h3>
                <p className="text-lg max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
              </Link>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4 mt-4">
                {icons.map((icon, i) => (
                  <div key={i} className="text-2xl text-gray-500 cursor-pointer hover:text-black transition">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Pagination Controls */}
      <div className="flex justify-center items-center mt-10 space-x-4">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded-md ${currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-black text-white hover:bg-black"}`}
        >
          Previous
        </button>

        <span className="text-xl font-semibold">{currentPage} - {totalPages}</span>

        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded-md ${currentPage === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-black text-white hover:bg-black"}`}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Display;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";

// const icons = [
//   { name: "Coffee Shop", icon: <FaCoffee /> },
//   { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
//   { name: "Fish & Seafood", icon: <FaFish /> },
//   { name: "Supermarket", icon: <FaStore /> },
//   { name: "Restaurant", icon: <FaUtensils /> },
//   { name: "Ice Cream", icon: <FaIceCream /> },
//   { name: "Chocolate", icon: <FaCookieBite /> },
// ];

// const models = [
//   { name: "Vista", image: "images/vista2.jpg", description: "Compact display units with large capacity and superior visibility." },
//   { name: "Minimal", image: "images/newminimal.jpg", description: "Less is more, a multitude of options for endless configurations." },
//   { name: "E-Line", image: "images/neweline.jpg", description: "Versatile and compact, ideal for medium-sized stores." },
//   { name: "Daisy", image: "images/newdaisy.jpg", description: "Versatile and functional display units with all the options for food retail and foodservice." },
//   { name: "Kubo", image: "images/newkubo.jpg", description: "An urban and contemporary concept." },
//   { name: "Scoop", image: "images/newscoop.jpg", description: "Performance and visibility, your ice cream always at its best." },
//   { name: "Iris", image: "images/newiris.jpg", description: "The visibility and the highlight that your products deserve." },
//   { name: "Columbs", image: "images/newcolumbs.jpg", description: "High capacity and visibility without obstacles." },
//   { name: "Pura", image: "images/newpura.jpg", description: "The ultimate gelato experience." },
//   { name: "Prestige 2", image: "images/newprestige2.jpg", description: "The display that loves your Meat and Charcuterie products." },
//   { name: "Passion Lux", image: "images/newpassionlux.jpg", description: "Wide area of exposure and sophistication in a single exhibitor." },
// ];

// function Display() {
//   const itemsPerPage = 6;
//   const [currentPage, setCurrentPage] = useState(1);

//   const totalPages = Math.ceil(models.length / itemsPerPage);

//   const handleNext = () => {
//     if (currentPage < totalPages) setCurrentPage(currentPage + 1);
//   };

//   const handlePrevious = () => {
//     if (currentPage > 1) setCurrentPage(currentPage - 1);
//   };

//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const selectedModels = models.slice(startIndex, startIndex + itemsPerPage);

//   return (
//     <div className="w-full font-thin mb-20">
//       {/* Hero Section */}
//       <section
//         className="relative text-center w-full h-[600px]"
//         style={{
//           backgroundImage: "url('images/displaycasesland.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       ></section>

//       {/* Models Display */}
//       <section className="px-6 md:px-32">
//         <div className="flex flex-col items-center justify-center text-black p-6">
//           <h1 className="text-3xl mb-4 md:text-4xl text-center">Display Cases & Serve-Overs</h1>
//           <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
//             Cold, hot, or dry/ambient, for Ice-cream, Chocolates, etc., we offer a complete range of Display Cases and Serve-Overs.
//           </p>
//         </div>

//         <div className="flex justify-center">
//           <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
//           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline uppercase mt-6">Typologies</Link>
//         </div>
//       </section>

//       {/* Products Grid */}
//       <section className="px-2 lg:px-32">
//         <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
//           {selectedModels.map((model, index) => (
//             <div key={index} className="text-center">
//               <Link to={`/product/${model.name}`}>
//                 <div
//                   className="relative w-full h-80 md:mb-4"
//                   style={{
//                     backgroundImage: `url(${model.image})`,
//                     backgroundSize: "contain",
//                     backgroundPosition: "center",
//                     backgroundRepeat: "no-repeat",
//                     height: "300px",
//                   }}
//                 ></div>
//                 <h3 className="text-3xl font-thin mb-2">{model.name}</h3>
//                 <p className="text-lg max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
//               </Link>

//               {/* Small icons under each model */}
//               <div className="flex justify-center gap-4">
//                 {icons.map((icon, index) => (
//                   <div key={index} className="text-2xl text-gray-500">{icon.icon}</div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Pagination Controls */}
//       <div className="flex justify-center items-center mt-10 space-x-4">
//         <button
//           onClick={handlePrevious}
//           disabled={currentPage === 1}
//           className={`px-4 py-2 rounded-md ${currentPage === 1 ? "bg-gray-300 cursor-not-allowed" : "bg-black text-white hover:bg-black"}`}
//         >
//           Previous
//         </button>

//         <span className="text-xl font-semibold">{currentPage} - {totalPages}</span>

//         <button
//           onClick={handleNext}
//           disabled={currentPage === totalPages}
//           className={`px-4 py-2 rounded-md ${currentPage === totalPages ? "bg-gray-300 cursor-not-allowed" : "bg-black text-white hover:bg-black"}`}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Display;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import { FaCoffee, FaBreadSlice, FaFish, FaStore, FaUtensils, FaIceCream, FaCookieBite } from "react-icons/fa";

// const icons = [
//   { name: "Coffee Shop", icon: <FaCoffee /> },
//   { name: "Bakery & Pastry", icon: <FaBreadSlice /> },
//   { name: "Fish & Seafood", icon: <FaFish /> },
//   { name: "Supermarket", icon: <FaStore /> },
//   { name: "Restaurant", icon: <FaUtensils /> },
//   { name: "Ice Cream", icon: <FaIceCream /> },
//   { name: "Chocolate", icon: <FaCookieBite /> },
// ];

// const models = [
//   {
//     name: "Vista",
//     image: "images/vista2.jpg",
//     description: "Compact display units with large capacity and superior visibility.",
//   },
//   {
//     name: "Minimal",
//     image: "images/newminimal.jpg",
//     description: "Less is more, a multitude of options for endless configurations.",
//   },
//   {
//     name: "E-Line",
//     image: "images/neweline.jpg",
//     description: "Versatile and compact, ideal for medium-sized stores.",
//   },
//   {
//     name: "Daisy",
//     image: "images/newdaisy.jpg",
//     description: "Versatile and functional display units with all the options for food retail and foodservice.",
//   },
//   {
//     name: "kubo",
//     image: "images/newkubo.jpg",
//     description: "An urban and contemporary concept.",
//   },
//   {
//     name: "Scoop",
//     image: "images/newscoop.jpg",
//     description: "Performance and visibility, your ice cream always at its best.",
//   },
//   {
//     name: "Iris",
//     image: "images/newiris.jpg",
//     description: "The visibility and the highlight that your products deserves.",
//   },
//   {
//     name: "Columbs",
//     image: "images/newcolumbs.jpg",
//     description: "High capacity and visibility without obstacles.t.",
//   },
//   {
//     name: "Pura",
//     image: "images/newpura.jpg",
//     description: "The ultimate gelato experience.",
//   },
//   {
//     name: "Prestige 2",
//     image: "images/newprestige2.jpg",
//     description: "The display that loves your Meat and Charcuterie products.",
//   },
//   {
//     name: "Passion lux",
//     image: "images/newpassionlux.jpg",
//     description: "Wide area of exposure and sophistication in a single exhibitor.",
//   },
//   // {
//   //   name: "kubo",
//   //   image: "images/newkubo.jpg",
//   //   description: "Wide area of exposure and sophistication in a single exhibitor.",
//   // },
// ];

// function Display() {
//   return (
//     <div className="w-full font-thin mb-20">
//       {/* Hero Section */}
// <section
// className="relative text-center w-full h-[600px]"
// style={{
//   backgroundImage: "url('images/displaycasesland.jpg')",
//   backgroundSize: "cover",
//   backgroundPosition: "center",
//   backgroundRepeat: "no-repeat",
// }}
// >

// </section>

// {/* Models Display */}
// <section className="px-6  md:px-32 ">
// <div className=" flex flex-col items-center justify-center  text-black p-6">
//   <h1 className="text-3xl mb-4 md:text-4xl text-center">Display Cases & Serve-Overs</h1>
//   <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
//   Cold, hot or dry/ambient, for Ice-cream, Chocolates, …, we offer a complete range of Display Cases and Serve-Overs, with different styles and for the most varied sectors, which allow an always perfect look!
//   </p>
// </div>

// <div className=" flex justify-center">
//   <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
//   <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline uppercase  mt-6">Typologies</Link>

//   {/* <button to="" className=" py-1 pl-4  mt-6">Display</button> */}
// </div>
// </section>
//       <section className="px-2 lg:px-32">
//         <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10">
//           {models.map((model, index) => (
//             <div key={index} className="text-center">
//               <Link to={`/product/${model.name}`}>
//                 <div
//                   className="relative w-full h-80 md:mb-4"
//                   style={{
//                     backgroundImage: `url(${model.image})`,
//                     backgroundSize: "contain",
//                     backgroundPosition: "center",
//                     backgroundRepeat: "no-repeat",
//                     height: "300px",
//                   }}
//                 ></div>
//                 <h3 className="text-3xl  font-thin mb-2">{model.name}</h3>
//                 <p className="text-lg max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>
//               </Link>

//               {/* Small icons under each model */}
//               <div className="flex justify-center gap-4">
//                 {icons.map((icon, index) => (
//                   <div key={index} className="text-2xl text-gray-500">{icon.icon}</div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Display;




// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { DisplayBannerGetdata, DisplayProductsGet } from "../Apihandlling";
// import { motion } from "framer-motion";
// import {
//   FaCoffee,
//   FaBreadSlice,
//   FaFish,
//   FaStore,
//   FaUtensils,
//   FaIceCream,
//   FaCookieBite,
// } from "react-icons/fa";

// const icons = [
//   { name: "Coffee Shop", icon: <FaCoffee className="text-xl text-gray-700" /> },
//   { name: "Bakery & Pastry", icon: <FaBreadSlice className="text-xl text-gray-700" /> },
//   { name: "Fish & Seafood", icon: <FaFish className="text-xl text-gray-700" /> },
//   { name: "Supermarket", icon: <FaStore className="text-xl text-gray-700" /> },
//   { name: "Restaurant", icon: <FaUtensils className="text-xl text-gray-700" /> },
//   { name: "Ice Cream", icon: <FaIceCream className="text-xl text-gray-700" /> },
//   { name: "Chocolate", icon: <FaCookieBite className="text-xl text-gray-700" /> },
// ];

// function Display() {
//   const [bannerData, setBannerData] = useState([]);
//   const [modelData, setModelData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 6;
//   const navigate = useNavigate();

//   useEffect(() => {
//     DisplayBannerGetdata()
//       .then((data) => {
//         console.log("Banner Data:", data);
//         setBannerData(data);
//       })
//       .catch((error) => console.error("Error fetching banner data:", error));
//   }, []);

//   useEffect(() => {
//     DisplayProductsGet()
//       .then((data) => {
//         console.log("Product Data:", data);
//         setModelData(data);
//       })
//       .catch((error) => console.error("Error fetching product data:", error));
//   }, []);

//   const handleProductClick = (product) => {
//     navigate(`/product/${product.id}`, { state: { product } });
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = modelData.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(modelData.length / itemsPerPage);

//   return (
//     <div className="font-playfair">
//       {bannerData.length > 0 ? (
//         <section className="relative w-full h-[500px] md:h-screen">
//           <img
//             src={bannerData[0].landingimage || ""}
//             alt="Banner"
//             className="absolute inset-0 w-full h-full object-cover"
//           />
//           {/* <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 sm:px-10 bg-black/40">
//             <h1 className="text-4xl sm:text-6xl font-bold uppercase text-white">
//               {bannerData[0].landingtext || "Landing Text"}
//             </h1>
//             <p className="text-lg sm:text-xl text-white max-w-3xl mt-2">
//               {bannerData[0].landingdescription || "Landing Description"}
//             </p>
//           </div> */}
//         </section>
//       ) : (
//         <section className="h-screen flex items-center justify-center bg-gray-200">
//           <motion.div
//             className="p-6 text-center"
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 1, ease: "easeInOut" }}
//           >
//             <h1 className="text-4xl md:text-6xl font-bold text-gray-800 animate-pulse">
//               Loading...
//             </h1>
//           </motion.div>
//         </section>
//       )}

//       <div className=" flex flex-col items-center justify-center text-center px-6 mt-12">
//       <h1 className="text-4xl sm:text-6xl font-bold uppercase text-black">
//   {bannerData?.[0]?.landingtext || "Landing Text"}
// </h1>
// <p className="text-lg sm:text-xl text-black max-w-3xl mt-2">
//   {bannerData?.[0]?.landingdescription || "Landing Description"}
// </p>

//           <div className=" flex justify-center">
//         <Link to="/" className="block py-1 pl-4 hover:underline text-blue-400 mt-6">Home -</Link>
//         <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline  mt-6">Models -</Link>

//         <button to="" className=" py-1 pl-4  mt-6">Display</button>
// </div>
//       </div>

//       <section className="py-16 bg-white text-center px-6 sm:px-10">
//         {/* <h2 className="text-3xl sm:text-5xl font-bold text-gray-800 mb-10">
//           Display Models
//         </h2> */}
//         <div className="container mx-auto max-w-6xl">
//           {currentItems.length > 0 ? (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
//               {currentItems.map((item, index) => (
//                 <div
//                   key={index}
//                   className="text-center flex flex-col items-center cursor-pointer"
//                   onClick={() => handleProductClick(item)}
//                 >
//                   <img
//                     src={item.image}
//                     alt={item.text}
//                     className="w-full max-w-3xl h-64 object-cover rounded-md"
//                   />
//                   <h3 className="text-xl font-semibold text-gray-800 mt-4">
//                     {item.text}
//                   </h3>
//                   <p className="text-gray-600 mt-2 text-sm leading-relaxed max-w-md">
//                     {item.textdescription}
//                   </p>
//                   <div className="flex gap-2">
//                     {icons.map((iconItem, index) => (
//                       <div key={index} className="flex">
//                         {iconItem.icon}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-xl text-gray-500">No model data available</p>
//           )}
//         </div>
//         <div className="flex justify-center items-center mt-6 space-x-4">
//           <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="px-4 py-2 bg-zinc-800 text-white rounded disabled:opacity-50">Previous</button>
//           <span className="text-lg font-semibold">Page {currentPage} of {totalPages}</span>
//           <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} className="px-4 py-2 bg-zinc-800 text-white rounded disabled:opacity-50">Next</button>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Display;


